import { render, staticRenderFns } from "./ObjectEditForm.vue?vue&type=template&id=02ac83e6&"
import script from "./ObjectEditForm.vue?vue&type=script&lang=js&"
export * from "./ObjectEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports